import React from 'react'
import { AiFillFacebook,AiFillLinkedin,AiFillGithub,AiFillYoutube } from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";
import './socialmedia.css'

export default function SocialMedia() {
    return (
        <div className='socialcontent' >
             <a href="https://web.facebook.com/abi.wickramarathna" target="_blank" rel="noopener noreferrer"><i className='fb'><FaFacebookSquare/></i></a>
             <a href="https://www.linkedin.com/in/abilasha-wickramarathna-8710533b1/" target="_blank" rel="noopener noreferrer"><i className='linkdin'><AiFillLinkedin /></i></a>
             <a href="https://github.com/abilasha1995" target="_blank" rel="noopener noreferrer"><i className='hub'><AiFillGithub /></i></a>
             <a href="https://www.youtube.com/@abi-po9rx?sub_confirmation=1" target="_blank" rel="noopener noreferrer"><i className='youtube'><AiFillYoutube /></i></a>
        </div>
    )
}
